import React, { Component } from 'react';
import '../PageNumber/PageNumber.scss';
class PageNumber extends Component {

  render() {
    console.log(this.props);

    return (
      <div className="standard-padding" id="pageNumber">
        <div className="content-wrapper container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              ~ { this.props.pageNumber ? this.props.pageNumber : "" } ~
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default PageNumber;
